<template>
   <div class="banner_bottom_agile_info dir-rtl">
	    <div class="container">
		<!---728x90--->

			<div class="agile_ab_w3ls_info row">
				<div class="col-md-6 ab_pic_w3ls fl-right">
				   	<img src="https://radap.ir/imagesUploaded/main/about.jpg" alt=" " class="img-responsive rounded" />
				</div>
				 <div class="col-md-6 ab_pic_w3ls_text_info " style="font-size: 17px;">
				    <h5> <span>درباره تیم راداَپ</span> </h5>
					<p>
						با سلام و خیر مقدم خدمت همراهان همیشگی ما و همچنین همشهریان گرامی
						هدف ما از راه اندازی این سایت:
					</p>
					<p>
						ارائه خدمات به همشهریان، دسترسی عموم مردم به تنوع محصولات با قیمت مناسب و برطرف کردن مایحتاج روزانه شما عزیزان است،
						در همین راستا سعی بر این داریم که هر کالایی را که ممکن است در سوپر مارکت ها وجود داشته باشد در این سایت در قالب سوپر مارکت های آنلاین ایجاد کنیم و در کوتاه ترین بازه ی زمانی اقلام سفارشی شما عزیزان را با پیک درب منزل تحویل دهیم.

						و همچنین در کنار سوپر مارکت های آنلاین ، رستوران و فست فودهای اینترنتی هم گامی دیگر در ارائه خدمات راداَپ به شما عزیزان میباشد.
						با سعی بر این مهم خواستیم با بهترین رستوران ها از لحاظ قیمت و کیفیت به راحتی و با چند کلیک ساده غذا یا پیتزا و ساندویچ مورد نظر خود را درب منزل تحویل بگیرید.

						صرفه جویی در وقت و هزینه…
					</p>
				</div>
			</div>  
		 </div> 
    </div>
</template>

<script>
export default {
name:"AboutBanner"
}
</script>

<style scoped>
*{
	font-family: 'IranSans';
	font-weight: 700;
}
.fl-right{
	float: right;
}
.agile_ab_w3ls_info h5 {
    font-weight: 300 !important;
}
.agile_ab_w3ls_info h5 span{
    font-weight: 700 !important;
}
</style>